/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { history } from '../helpers';
/**
 * Get auth object from local storage
 */

const getAuth = () => {
  const authData = localStorage.getItem('theraytekjwt');
  const auth = authData ? JSON.parse(authData).token : null;


  return auth;
};
/**
 * Create axios instance.
 *
 * @type {AxiosInstance}
 */

const auth = getAuth();
const axiosInstance = (() => {
  const params = {};
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  };
  if (auth) {
    Object.assign(headers, { Authorization: `Bearer ${auth}` });
  }
  
  axios.defaults.headers.common.Authorization = `Bearer ${auth}`;
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    params: params,
    headers: headers
  });
})();

axiosInstance.interceptors.request.use(
  function (config) {
    const token = getAuth();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  function (error) {

    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  data => {
    return Promise.resolve(data);
  },
  error => {
    console.log('error', error.response)
    if (error.response && error.response.status && error.response.status === 401) {
      delete axios.defaults.headers.Authorization;
      localStorage.clear()
     
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
